/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Race } from '../../models/race';

export interface Races$Params {
}

export function races(http: HttpClient, rootUrl: string, params?: Races$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Race>>> {
  const rb = new RequestBuilder(rootUrl, races.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Race>>;
    })
  );
}

races.PATH = '/races';
